import { createWebappRoute, getRouter } from '../helpers';

export default [
  createWebappRoute({
    path: '/refer',
    name: 'refer-module',
    component() {
      console.log('ROUTER, refer');

      // eslint-disable-next-line jquery/no-class
      if ($('body').hasClass('modal-open')) {
        return false;
      }

      getRouter().push('home');
      $('#refer-modal').modal('show');

      return {};
    },
  }),
];
